/**
 * Central registry of all SDK event bus keys.
 *
 * Every event name used across the app must be defined here. This prevents
 * typo-silent mismatches and ensures that renaming an event only requires a
 * change in this file.
 *
 * Usage:
 *   import { eventKeys } from '@/lib/eventKeys';
 *
 *   useGetEventBus(eventKeys.mails.updated, handler)
 *   offMailUpdated(eventKeys.mails.updated, handler)
 */

export const eventKeys = {
    // ─── Custom Views ─────────────────────────────────────────────────────────
    customView: {
        listUpdated: "custom-view-list-updated",
    },

    // ─── Mails ────────────────────────────────────────────────────────────────
    mails: {
        updated: "mail-updated",
        deleted: "mail-deleted",
        newInbox: "mails-new-mails",
        threadUpdated: "thread-updated",
    },

    // ─── Network ──────────────────────────────────────────────────────────────
    network: {
        offlineThreshold: "network-offline-threshold-reached",
        online: "network-online",
    },

    // ─── Startup ──────────────────────────────────────────────────────────────
    startup: {
        failed: "startup-failed",
    },

    // ─── Todos ────────────────────────────────────────────────────────────────
    todos: {
        updated: "user-todos-updated",
    },

    // ─── User ─────────────────────────────────────────────────────────────────
    user: {
        authenticated: "user-authenticated",
    },
} as const;

export type EventKey =
    (typeof eventKeys)[keyof typeof eventKeys][keyof (typeof eventKeys)[keyof typeof eventKeys]];
